import { render, staticRenderFns } from "./JdsActionBox.vue?vue&type=template&id=65e1526b&scoped=true&"
import script from "./JdsActionBox.vue?vue&type=script&lang=ts&"
export * from "./JdsActionBox.vue?vue&type=script&lang=ts&"
import style0 from "./JdsActionBox.vue?vue&type=style&index=0&id=65e1526b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e1526b",
  null
  
)

export default component.exports